// @ts-strict-ignore

import * as React from 'react';
import Helmet from 'react-helmet';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';

import 'antd/dist/antd.css';
import { Spin } from 'antd';

import { appConfig } from '@frontend/app/config';

import { Home } from '@frontend/app/containers';
import { useAuth } from '@frontend/context/authContext';

import { LoginView } from './LoginView';

import styles from './App.scss';

/**
 * @extends {React.Component}
 */
const App: React.FunctionComponent<React.PropsWithChildren<{}>> = React.memo(() => {
  const { loading, isAuthenticated, authError, targetUrl, apolloClient, loginWithRedirect } = useAuth();

  return (
    <div className={styles.App}>
      <Helmet {...appConfig.app} {...appConfig.app.head} />
      {loading && <Spin size="large" className={styles.spinner} />}
      {!loading && !isAuthenticated && <LoginView error={authError} onSignIn={loginWithRedirect} />}
      {!loading &&
        isAuthenticated &&
        (apolloClient ? (
          <ApolloHooksProvider client={apolloClient}>
            <Home targetUrl={targetUrl} />
          </ApolloHooksProvider>
        ) : (
          // Render Home without Apollo while it's being initialized
          // This ensures routing is always available
          <Home targetUrl={targetUrl} />
        ))}
    </div>
  );
});

export default App;
